// Real Midwest Made team photos (user-provided).
const A1 = "https://customer-assets-jt897jd0.emergentagent.net/job_dogtraining-hub-3/artifacts/fy2mfyoo_Untitled%20design%20-%201.png"; // solo, ear pro, portrait
const A2 = "https://customer-assets-jt897jd0.emergentagent.net/job_dogtraining-hub-3/artifacts/j0jp4d1h_Untitled%20design%20-%202.png"; // shooting pistol, action
const A4 = "https://customer-assets-jt897jd0.emergentagent.net/job_dogtraining-hub-3/artifacts/daxomasu_Untitled%20design%20-%204.png"; // group at table with rifles, landscape
const A5 = "https://customer-assets-jt897jd0.emergentagent.net/job_dogtraining-hub-3/artifacts/ufmcty05_Untitled%20design%20-%205.webp"; // three-man team posing, landscape

export const COURSE_IMAGES = {
  "pistol-fundamentals": A1,
  "ccw": A2,
  "rifle-carbine": A4,
  "private-coaching": A5,
};

export const HERO_IMAGE = A2;
export const MIDWEST_TEXTURE = A4;
export const INSTRUCTOR_IMAGE = A5;
